// Script para resaltar el campo Amount en Invoice#show
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Vue components to render
  setTimeout(function() {
    highlightInvoiceAmount();
    
    // Also run periodically in case the content changes
    setInterval(highlightInvoiceAmount, 2000);
  }, 1000);
});

function highlightInvoiceAmount() {
  // Find the invoice detail component
  const invoiceDetail = document.querySelector('.invoice-detail');
  if (!invoiceDetail) return;
  
  // Find all dt elements (labels)
  const labels = invoiceDetail.querySelectorAll('dt');
  
  labels.forEach(label => {
    const labelText = label.textContent.toLowerCase();
    
    // Look for amount, total, or similar terms
    if (labelText.includes('amount') || 
        labelText.includes('total') || 
        labelText.includes('precio') || 
        labelText.includes('monto')) {
      
      // Find the corresponding dd element (value)
      const valueElement = label.nextElementSibling;
      if (valueElement && valueElement.tagName === 'DD') {
        const paragraphElement = valueElement.querySelector('p');
        if (paragraphElement) {
          // Add the highlighting class
          paragraphElement.classList.add('invoice-amount-highlight');
          
          // Also add to the parent active-value div
          const activeValueDiv = paragraphElement.closest('div[class*="active-value"]') || 
                               paragraphElement.closest('div');
          if (activeValueDiv) {
            activeValueDiv.classList.add('active-value-amount');
          }
          
          console.log('Highlighted invoice amount field:', paragraphElement.textContent);
        }
      }
    }
  });
}
